import React, { useEffect, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { useMediaQuery } from 'react-responsive';
import { useNavigate, useParams } from 'react-router-dom';

import { useSingleBillStatementQuery } from 'apollo/queries/autogenerate/hooks';
import Loading from 'shared/modules/common/components/atoms/Loading';
import BankTransfer from 'shared/modules/settlement/components/organisms/BankTransfer';
import { ACTION, SCREEN } from 'shared/modules/settlement/constants/mixpanel';
import Mixpanel from 'shared/vendor/Mixpanel';
import NavigationBar from 'web/modules/common/components/molecules/NavigationBar';

const BankTransferScreen = () => {
  const isBigScreen = useMediaQuery({ minWidth: 768 });
  const isHugeScreen = useMediaQuery({ minWidth: 1024 });
  const { id } = useParams();
  const navigate = useNavigate();
  const [isVanError, setIsVanError] = useState(false); // If for some reason getting the user's VAN failed

  useEffect(() => {
    const eventName = `${SCREEN.BANK_TRANSFER} - ${ACTION.PAGE_VIEW}`;

    Mixpanel.timeEvent(eventName);

    return () => Mixpanel.trackEvent(eventName);
  }, []);

  useEffect(() => {
    const eventName = `${SCREEN.BANK_TRANSFER_FALLBACK} - ${ACTION.PAGE_VIEW}`;

    Mixpanel.timeEvent(eventName);

    return () => {
      if (isVanError) {
        Mixpanel.trackEvent(eventName);
      }
    };
  }, [isVanError]);

  const { data: billData, loading: loading } = useSingleBillStatementQuery({
    fetchPolicy: 'network-only',
    variables: {
      id: id?.trim() as string,
    },
  });

  if (loading) {
    return <Loading />;
  }

  if (!id?.trim() || !billData) {
    return null;
  }

  return (
    <View style={[style.screen, isBigScreen && style.screenBigScreen]}>
      <View style={[style.container, isBigScreen && style.containerBigScreen]}>
        <View style={isHugeScreen && style.bankTransferHugeScreen}>
          <NavigationBar
            title="お客様専用振込口座"
            onBackButtonPress={() => navigate(-1)}
            id="navigation-bar"
          />
          <BankTransfer
            // For unpaid bills, use outstandingAmount. This amount changes for any user activities
            // e.g partially pay the bill or make refunds.
            // This automatically includes the lateFeeAmount if the bill becomes OVERDUE.
            // Do not use unpaidAmount + lateFeeAmount.
            outstandingAmount={billData.billStatement.outstandingAmount}
            onError={() => setIsVanError(true)}
          />
        </View>
      </View>
    </View>
  );
};

const style = StyleSheet.create({
  // Template for building a new main screen
  // Scrolls on overflow for both mobile and desktop
  screen: {
    alignItems: 'center',
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 0,
    overflow: 'scroll',
    paddingVertical: 24,
    paddingHorizontal: 16,
  },
  screenBigScreen: {
    paddingHorizontal: 24,
  },
  container: {
    width: '100%',
  },
  containerBigScreen: {
    maxWidth: 960,
  },
  bankTransferHugeScreen: {
    width: '50%',
    paddingRight: 24,
  },
});

export default BankTransferScreen;
